import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Curriculum on curricula {
    id
    name
  }
  fragment Module on modules {
    id
    name
    approach
    order
    curriculum_id
    exercises(
      where: { deleted: { _neq: true } }
      order_by: [{ order: asc_nulls_last }]
    ) {
      id
      name
      description
      duration
      type
      meeting_type
      blocks
      module_id
      order
      tags  
    }
    deleted
  }
  fragment Exercise on exercises {
    id
    name
    description
    duration
    type
    meeting_type
    blocks
    module_id
    order
    tags  
    module {
      id
      name
    }
    created_at
    updated_at
  }
`;

export const GET_CURRICULA = gql`
  query getcurricula {
    curricula(order_by: [{ name: asc }]) {
      ...Curriculum
    }
  }
  ${FRAGMENT}
`;

export const CREATE_CURRICULUM = gql`
  mutation addCurriculum($data: curricula_insert_input!) {
    insert_curricula_one(object: $data) {
      ...Curriculum
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_CURRICULUM = gql`
  mutation updateCurriculum($id: Int!, $data: curricula_set_input!) {
    update_curricula_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Curriculum
    }
  }
  ${FRAGMENT}
`;

export const DELETE_CURRICULUM = gql`
    mutation deleteCurriculum($id: Int!) {
        delete_curricula_by_pk(id: $id) {
            id
        }
    }
`;

export const GET_MODULE = gql`
  query get($id: Int!) {
    modules(where: { id: { _eq: $id } }) {
      ...Module
    }
  }
  ${FRAGMENT}
`;

export const GET_MODULES = gql`
  query getModules($curriculum_id: Int!) {
    modules(
      where: { curriculum_id: { _eq: $curriculum_id }, deleted: { _neq: true } }
      order_by: [{ order: asc_nulls_last }]
    ) {
      ...Module
    }
    curriculum: curricula_by_pk(id: $curriculum_id) {
      id
      name
    }
  }
  ${FRAGMENT}
`;

export const GET_ALL_MODULES = gql`
    query getAllModules {
        modules(
            where: { deleted: { _neq: true } }
            order_by: [{ order: asc_nulls_last }]
        ) {
            id
            name
            approach
            order
            curriculum_id
            curriculum {
                id
                name
            }
            exercises(
                where: { deleted: { _neq: true } }
                order_by: [{ order: asc_nulls_first }]
            ) {
                id
                name
                description
                duration
                type
                meeting_type
                module_id
                tags
            }
            deleted
        }
    }
    ${FRAGMENT}
`;

export const SAVE_MODULE = gql`
  mutation save($input: modules_insert_input!) {
    modules: insert_modules(objects: [$input]) {
      returning {
        ...Module
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_MODULE = gql`
  mutation($id: Int!, $input: modules_set_input!) {
    modules: update_modules(where: { id: { _eq: $id } }, _set: $input) {
      returning {
        ...Module
      }
    }
  }
  ${FRAGMENT}
`;

export const SORT_MODULES = gql`
  mutation sortModule($id1: Int!, $order1: Int!, $id2: Int!, $order2: Int!) {
    one: update_modules(
      where: { id: { _eq: $id1 } }
      _set: { order: $order1 }
    ) {
      returning {
        id
        order
      }
    }
    two: update_modules(
      where: { id: { _eq: $id2 } }
      _set: { order: $order2 }
    ) {
      returning {
        id
        order
      }
    }
  }
  ${FRAGMENT}
`;

export const SORT_EXERCISES = gql`
  mutation sortExercise($id1: Int!, $order1: Int!, $id2: Int!, $order2: Int!) {
    one: update_exercises(
      where: { id: { _eq: $id1 } }
      _set: { order: $order1 }
    ) {
      returning {
        id
        order
      }
    }
    two: update_exercises(
      where: { id: { _eq: $id2 } }
      _set: { order: $order2 }
    ) {
      returning {
        id
        order
      }
    }
  }
  ${FRAGMENT}
`;

export const GET_EXERCISE = gql`
  query get($id: Int!) {
    exercises(where: { id: { _eq: $id } }) {
      ...Exercise
    }
  }
  ${FRAGMENT}
`;

export const ADD_EXERCISE = gql`
  mutation add($input: exercises_insert_input!) {
    exercises: insert_exercises(objects: [$input]) {
      returning {
        ...Exercise
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_EXERCISE = gql`
  mutation update($id: Int!, $input: exercises_set_input!) {
    exercises: update_exercises(where: { id: { _eq: $id } }, _set: $input) {
      returning {
        ...Exercise
      }
    }
  }
  ${FRAGMENT}
`;

export const SEARCH_EXERCISES = gql`
  query search($query: String) {
    exercises(
      where: {
        name: { _ilike: $query }
        type: { _eq: "worksheet" }
        deleted: { _neq: true }
      }
      limit: 10
    ) {
      id
      name
      module {
        id
        name
      }
    }
  }
`;
